import React, { useState, useEffect, useRef  } from "react";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import { SelectPicker, DatePicker, Dropdown, Tabs } from "rsuite";
import "rsuite/DatePicker/styles/index.css";
import "rsuite/SelectPicker/styles/index.css";
import "rsuite/Dropdown/styles/index.css";
import IconNoData from "../images/IconNoData.svg";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, TooltipProvider } from "react-tooltip";

const Test1 = (props) => {


  const fetchFinancialData = async () => {
    try {
      const response = await fetch(
        "https://typesense.infomanav.in/collections/lembda_company_financials_series/documents/search?q=*&per_page=5&filter_by=company_symbol%3A000004.SZ",
        {
          method: "GET",
          headers: {
            "x-typesense-api-key": "WwQySUDzbI3tNEozoarFJM9dsKFbeaXjNFKROidedC4ZFjD5", // Replace with your actual API key
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log("Financial Data:", data);
    } catch (error) {
      console.error("Error fetching financial data:", error);
    }
  };
  
  // Call the function where needed
  fetchFinancialData();
  


  return (
    <>
      <Sidebar />
    <h5>Hi</h5>
    </>
  );
};

export default Test1;
